/* Generated by tools/generate-brand-assets.mjs. Do not edit manually. */
import type { Brand } from '@crm/theme';

export const BRAND: Brand = {
  "name": "Mello CRM",
  "shortName": "Mello",
  "description": "Mello CRM is a customer relationship management application for mortgage professionals.",
  "startUrl": "/",
  "display": "standalone",
  "orientation": "portrait",
  "themeColor": "#07090d",
  "themeColorDark": "#111827",
  "backgroundColor": "#ffffff",
  "backgroundColorDark": "#111827",
  "assets": {
    "favicon": "/favicon.svg?v=mello-2",
    "appleTouchIcon": "/apple-touch-icon.png?v=mello-2",
    "icon192": "/icon-192.png?v=mello-2",
    "icon512": "/icon-512.png?v=mello-2",
    "maskableIcon512": "/maskable-icon-512.png?v=mello-2",
    "manifest": "/manifest.webmanifest?v=mello-2",
    "symbolDark": "/assets/mello-symbol-dark.svg",
    "symbolLight": "/assets/mello-symbol-light.svg",
    "wordmarkDark": "/assets/mello-wordmark-remainder-dark.svg",
    "wordmarkLight": "/assets/mello-wordmark-remainder-light.svg",
    "openGraphDefault": "/assets/og-default.png"
  }
} as const;
export default BRAND;
